<section>
  <div class="modal-title">
    <img class="padding8" src="{{ headerIcon }}" />
    <span><span class="title">Reset Password</span>
    <p class="warning-message">Please check your email and reset your password.</p></span>
  </div>
</section>
